import {
  transformDate,
  transformDatetime as transformDatetimeShared,
  transformTime,
} from "@onclicks/sharedmobilecommon/utils/transformDatetime";

/** Même logique que l'app mobile (heure de Bruxelles) ; seul le séparateur diffère. */
const transformDatetime = (date: Date | string, locale: string) =>
  transformDatetimeShared(date, locale, " • ");

export { transformDate, transformTime, transformDatetime };
